<template>
    <v-menu ref="menu"
            :close-on-content-click="false"
            v-model="menu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="disabled"
    >
        <v-text-field slot="activator"
                      :value="dateStr"
                      :label="label"
                      :hint="hint"
                      persistent-hint
                      :name="label"
                      readonly
                      data-vv-validate-on="input"
                      :data-vv-name="label"
                      append-icon="event"
                      :disabled="disabled"
                      :placeholder="placeholder"
                      :error-messages="errorMessages"
                      ref="text"
                      :clearable="clearable"
                      @click:clear="clearText()"
        ></v-text-field>
        <v-date-picker v-model="date"
                       type="date"
                       @input="menu = false"
                       @change="save"
                       :locale="locale"
                       :min="formatMinDate()"
                       :max="formatMaxDate()"
        ></v-date-picker>
    </v-menu>
</template>

<script>
    import moment from 'moment'
    import dateUtils from "../../../public/js/DateUtils"

    const current = moment()
    const currentDate = current.format('YYYY-MM-DD')
    export default {
        name: 'i-datepicker',
        inheritAttrs: false,
        data() {
            return {
                menu: false,
                date: null
            }
        },
        props: {
            hint: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: 'Date'
            },
            value: {
                type: String | Date,
                default: () => {
                    return currentDate;
                }
            },
            formatter: {
                type: String,
                default: "DD/MM/YYYY"
            },
            placeholder: {
                type: String,
                default: ""
            },
            readonly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            errorMessages: {
                type: String,
                default: ""
            },
            defaultValue: {
                type: Boolean,
                default: true
            },
            minDate: {
                type: String,
                default: ""
            },
            maxDate: {
                type: String,
                default: ""
            },
            clearable: {
                type: Boolean,
                default: false
            },
        },

        computed: {
            dateStr: function () {
                //console.log(this.date);
                try {
                    let str = moment(this.date).format(this.formatter);
                    if (str == "Invalid date") {
                        str = "";
                    }
                    // console.log(this.label, this.date, this.defaultValue);
                    if (this.date = null && !this.defaultValue) {
                        str = "";
                    }
                    //console.log(str);
                    return str;
                } catch (e) {
                    return "";
                }
            },

            locale: function () {
                return this.$i18n.locale;
            }
        },

        watch: {
            value: function (data) {
                //console.log("date change");
                //console.log(data);
                if (data == null) {
                    data = new Date();
                }
                /*                if (typeof data == "object") {
                                    this.date = data.toISOString().substr(0, 10);
                                } else {
                                    this.date = data.substr(0, 10);
                                }*/

                if (this.defaultValue) {
                    this.date = moment(data).format("YYYY-MM-DD");
                }
                
                //console.log(this.date);
                this.$emit('input', this.date);


            }
        },
        methods: {
            focus: function () {
                this.$refs.text.focus();
            },

            save(data) {
                if (this.readonly) {
                    return;
                }
                this.date = data;
                //console.log(this.date);
                //console.log(data);
                //this.$emit('input', moment(this.date).format(this.formatter));
                this.$emit('input', this.date);
                this.$emit("change", this.date);
            },
            clearText  : function () {
                this.date = null;
                this.$emit("clearText");
            },

            formatMinDate () {
                if (this.minDate != '') {
                    const minDate = this.minDate.length == 10 ? new Date(moment(String(this.minDate)).format('YYYY-MM-DD')).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
                    return minDate;
                } else {
                    return '';
                }
            },

            formatMaxDate () {
                if (this.maxDate != '') {
                    const maxDate = this.maxDate.length == 10 ? new Date(moment(String(this.maxDate)).format('YYYY-MM-DD')).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
                    return maxDate;
                } else {
                    return '';
                }
            },
            onClearClicked () {
                this.$emit('onClear');
            }
        },

        created() {
            if (this.value == null || this.value == undefined || this.value == "") {
                this.date = null;
            }
            //console.log(this.value);
            this.date = moment(this.value).format("YYYY-MM-DD");
            if (this.date == "Invalid date" || !this.defaultValue) {
                this.date = null;
            }
            // console.log(this.label, this.date, this.defaultValue);
            this.$emit('input', this.date);
        }
    }
</script>